// @flow
import * as React from "react"
import { push } from "connected-react-router"
import { compose, withHandlers, type HOC } from "recompose"
import withUser from "hoc/withUser"
import withSubmit from "hoc/withSubmit"
import withConnect from "hoc/withConnect"
import withMutation from "hoc/withMutation"
import ExtendReservationConfirm from "pages/Reservation/ExtendReservationConfirm"
import urls from "data/router/urls"
import { clear } from "data/search/actions"
import { openModal } from "data/modals/actions"
import { getDaysApart } from "data/units/date/helpers"
import { selectDates } from "data/reservations/selectors"
import type { OriginalReservation } from "data/reservations/types"
import { extendReservationMutation } from "data/reservations/graphql/mutations"
import Button from "components/Button"
import ReservationSuccess from "modals/ReservationSuccess"
import { trackReservation } from "analytics/reservations/analyticsTraits"
import { ButtonsWrap } from "./styled"

const ConfirmExtension = ({ submit, loading, cancelExtension }) => (
  <ButtonsWrap>
    <Button large onClick={submit} loading={loading} disabled={loading}>
      Confirm Extension
    </Button>
    <Button large secondary onClick={cancelExtension} loading={loading} disabled={loading}>
      Cancel
    </Button>
  </ButtonsWrap>
)

type Outter = {
  originalReservation: OriginalReservation,
  loading: boolean,
}

const mapDispatchToProps = {
  clear,
  openModal,
}

const mapStateToProps = state => ({
  dates: selectDates(state),
})

const enhancer: HOC<*, Outter> = compose(
  withUser(),
  withConnect(mapStateToProps, mapDispatchToProps),
  withMutation(extendReservationMutation),
  withSubmit({
    submit: props => () => {
      if (!props.dates || !props.originalReservation) {
        throw new Error("Impossible!")
      }

      return props.submitMutation({
        reservationId: props.originalReservation.resId,
        end: props.dates.endDate,
      })
    },
    redirect: (_, res) => urls.reservation(res.id),
    onSuccess: props => res => {
      props.clear()
      props.openModal(ReservationSuccess, {
        component: <ExtendReservationConfirm extendedReservation={res} />,
      })

      // Track extended days
      const extendedDays = getDaysApart(res.end, props.originalReservation.endDate)
      trackReservation(
        "Reservation Extended",
        res,
        props.user,
        { extendedDays: extendedDays },
      )
    },
  }),
  withHandlers({
    cancelExtension: props => () => {
      props.clear()
      push(urls.products)
    },
  }),
)

export default enhancer(ConfirmExtension)



// WEBPACK FOOTER //
// ./src/pages/Checkout/CheckoutForm/ConfirmExtension/index.js